import React from 'react';
import Helmet from 'react-helmet';
import { AppContext } from '../../Context/AppContext';
import BannerImage from '../../Components/BannerImage';
import Container from '../../Components/Container';
import ButtonLink from '../../Components/Button/ButtonLink';
import CardList from '../../Components/CardList';

function RouteHome() {
  return (
    <AppContext.Consumer>
      {({ locations }) => (
        <React.Fragment>
          <Helmet>
            <title>
              Fish Toronto
            </title>
          </Helmet>
          <BannerImage
            title="Fish Toronto"
            img="/images/Locations/1920_Island.jpeg"
          />
          <Container>
            <h2>
              Explore featured fishing locations in the GTA
            </h2>
            <CardList
              cards={locations.filter((loc) => {
                if (!loc.featured) {
                  return false;
                }

                return loc.featured;
              }).map(({
                name,
                imageThumbnail,
                route,
                summary,
              }) => Object({
                key: route,
                title: name,
                img: imageThumbnail,
                link: `/locations/${route}`,
                description: summary,
              }))}
            />
            <ButtonLink to="/locations">
              View more locations
            </ButtonLink>
          </Container>
        </React.Fragment>
      )
    }
    </AppContext.Consumer>
  );
}

export default RouteHome;



// WEBPACK FOOTER //
// ./src/Routes/RouteHome/index.jsx